import React, { useState } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Examples from './components/Examples';
import Goals from './components/Goals';
import CoreTools from './components/CoreTools';
import HowItWorks from './components/HowItWorks';
import USP from './components/USP';
import TrustedBy from './components/TrustedBy';
import Pricing from './components/Pricing';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';
import Demo from './components/Demo';
import WhatsAppButton from './components/WhatsAppButton';

function App() {
  const [demoOpen, setDemoOpen] = useState(false);
  const openDemo = () => setDemoOpen(true);

  return (
    <div className="min-h-screen bg-white text-ink font-sans selection:bg-violet-200 overflow-x-hidden">
      <Navbar />
      <main>
        <Hero onOpenDemo={openDemo} />
        <Examples />
        <Goals />
        <CoreTools />
        <HowItWorks />
        <USP />
        <TrustedBy />
        <Pricing />
        <CallToAction onOpenDemo={openDemo} />
      </main>
      <Footer />
      <Demo open={demoOpen} onOpenChange={setDemoOpen} />
      <WhatsAppButton />
    </div>
  );
}

export default App;
